/** @prettier */
import {GraphDataRange} from '../../../../Type/TypeDef';
import {graph} from '../../../../define';
import {barGraphBasicSetting} from './barGraphBasicSetting';
import {TFunction} from 'i18next';

/**
 * 消費電力グラフ 冷暖他表示 サイト単位 の表示設定
 * @param props props
 * @returns 表示設定
 */
export const individualSiteBarGraphSetting = (props: {
  xLabel: string[]; //X軸のラベル
  dateRange: GraphDataRange; //データ取得範囲
  csvFileNameDate: string; //CSVファイルの名前（日付部分）
  csvFileNameTarget: string; //CSVファイルの名前（サイトの名前 + グラフの対象の名前）
  barGraphDataCool: ApexAxisChartSeries['0']['data']; //積み上げグラフ一段目
  barGraphDataHot: ApexAxisChartSeries['0']['data']; //積み上げグラフ二段目
  barGraphDataOther: ApexAxisChartSeries['0']['data']; //積み上げグラフ三段目
  barGraphDataRTCool: ApexAxisChartSeries['0']['data']; //積み上げグラフ四段目
  barGraphDataRTHot: ApexAxisChartSeries['0']['data']; //積み上げグラフ五段目
  comparisonBarGraphDataCool: ApexAxisChartSeries['0']['data']; //積み上げグラフ一段目(別の日)
  comparisonBarGraphDataHot: ApexAxisChartSeries['0']['data']; //積み上げグラフ二段目(別の日)
  comparisonBarGraphDataOther: ApexAxisChartSeries['0']['data']; //積み上げグラフ三段目(別の日)
  comparisonBarGraphDataRTCool: ApexAxisChartSeries['0']['data']; //積み上げグラフ四段目(別の日)
  comparisonBarGraphDataRTHot: ApexAxisChartSeries['0']['data']; //積み上げグラフ五段目(別の日)
  trans: TFunction; //翻訳関数
}) => {
  /** Apex Chartsのseries設定
   * - name グラフの凡例
   * - type グラフの種類
   * - group グラフデータのグループ
   * - data グラフデータ
   */
  let seriesProps: ApexAxisChartSeries = [];

  //COMPARISONボタンの押下毎に、表示するグラフと凡例の数を切り替える。
  if (
    props.comparisonBarGraphDataCool.length > 0 ||
    props.comparisonBarGraphDataHot.length > 0 ||
    props.comparisonBarGraphDataOther.length > 0 ||
    props.comparisonBarGraphDataRTCool.length > 0 ||
    props.comparisonBarGraphDataRTHot.length > 0
  ) {
    //COMPARISONボタンの押下回数が奇数の場合、グラフと凡例を8つずつ表示する。
    //奇数:comparison**のデータをBarChartGraphから受け取る。(データ長≠0)
    //偶数:comparison**のデータをBarChartGraphから受け取らない。(データ長＝0)
    seriesProps = [
      {
        name: `${props.trans(
          'individualSiteBarGraphSetting.graphItem.comparisonACCooling'
        )}`,
        group: 'comparisonBarGraphPowerConsumption',
        data: props.comparisonBarGraphDataCool,
      },
      {
        name: `${props.trans(
          'individualSiteBarGraphSetting.graphItem.comparisonACHeating'
        )}`,
        group: 'comparisonBarGraphPowerConsumption',
        data: props.comparisonBarGraphDataHot,
      },
      {
        name: `${props.trans(
          'individualSiteBarGraphSetting.graphItem.comparisonACOther'
        )}`,
        group: 'comparisonBarGraphPowerConsumption',
        data: props.comparisonBarGraphDataOther,
      },
      {
        name: `${props.trans(
          'individualSiteBarGraphSetting.graphItem.comparisonOtherCooling'
        )}`,
        group: 'comparisonBarGraphPowerConsumption',
        data: props.comparisonBarGraphDataRTCool,
      },
      {
        name: `${props.trans(
          'individualSiteBarGraphSetting.graphItem.comparisonOtherHeating'
        )}`,
        group: 'comparisonBarGraphPowerConsumption',
        data: props.comparisonBarGraphDataRTHot,
      },
      {
        name: `${props.trans(
          'individualSiteBarGraphSetting.graphItem.acCooling'
        )}`,
        group: 'barGraphPowerConsumption',
        data: props.barGraphDataCool,
      },
      {
        name: `${props.trans(
          'individualSiteBarGraphSetting.graphItem.acHeating'
        )}`,
        group: 'barGraphPowerConsumption',
        data: props.barGraphDataHot,
      },
      {
        name: `${props.trans(
          'individualSiteBarGraphSetting.graphItem.acOther'
        )}`,
        group: 'barGraphPowerConsumption',
        data: props.barGraphDataOther,
      },
      {
        name: `${props.trans(
          'individualSiteBarGraphSetting.graphItem.otherCooling'
        )}`,
        group: 'barGraphPowerConsumption',
        data: props.barGraphDataRTCool,
      },
      {
        name: `${props.trans(
          'individualSiteBarGraphSetting.graphItem.otherHeating'
        )}`,
        group: 'barGraphPowerConsumption',
        data: props.barGraphDataRTHot,
      },
    ];
  } else {
    seriesProps = [
      {
        name: `${props.trans(
          'individualSiteBarGraphSetting.graphItem.acCooling'
        )}`,
        group: 'barGraphPowerConsumption',
        data: props.barGraphDataCool,
      },
      {
        name: `${props.trans(
          'individualSiteBarGraphSetting.graphItem.acHeating'
        )}`,
        group: 'barGraphPowerConsumption',
        data: props.barGraphDataHot,
      },
      {
        name: `${props.trans(
          'individualSiteBarGraphSetting.graphItem.acOther'
        )}`,
        group: 'barGraphPowerConsumption',
        data: props.barGraphDataOther,
      },
      {
        name: `${props.trans(
          'individualSiteBarGraphSetting.graphItem.otherCooling'
        )}`,
        group: 'barGraphPowerConsumption',
        data: props.barGraphDataRTCool,
      },
      {
        name: `${props.trans(
          'individualSiteBarGraphSetting.graphItem.otherHeating'
        )}`,
        group: 'barGraphPowerConsumption',
        data: props.barGraphDataRTHot,
      },
    ];
  }

  /** Apex Chartsのoptions設定
   * - xLabel X軸に表示するラベル
   * - csvFileNameDate csvファイル名に表示する日付
   * - csvFileNameTarget csvファイル名に表示するサイト名 + ユニット名
   * - trans 翻訳関数
   */
  let optionProps = barGraphBasicSetting({
    xLabel: props.xLabel,
    dateRange: props.dateRange,
    csvFileNameDate: props.csvFileNameDate,
    csvFileNameTarget: props.csvFileNameTarget,
    trans: props.trans,
  });

  /** グラフ配色一覧 */
  const graphColor = [
    graph.GRAPH_COLOR_COOL, //Cool 0 空調機冷房データ
    graph.GRAPH_COLOR_HEAT, //Heat 1 空調機暖房データ
    graph.GRAPH_COLOR_PANSY, //Pansy 2 空調機その他データ
    graph.GRAPH_COLOR_CYAN, //Cyan 3 熱源機冷房データ
    graph.GRAPH_COLOR_GOLD, //Gold 4 熱源機暖房データ
    graph.GRAPH_COLOR_LIGHT_COOL, //Light Cool 5 空調機冷房データ（比較）
    graph.GRAPH_COLOR_LIGHT_HEAT, //Light Heat 6 空調機暖房データ（比較）
    graph.GRAPH_COLOR_LIGHT_PANSY, //Light Pansy 7 空調機その他データ（比較）
    graph.GRAPH_COLOR_LIGHT_CYAN, //Light Cyan 8 熱源機冷房データ（比較）
    graph.GRAPH_COLOR_LIGHT_GOLD, //Light Gold 9 熱源機暖房データ（比較）
  ];

  //COMPARISONボタンの押下毎に、グラフの配色を切り替える。
  if (
    props.comparisonBarGraphDataCool.length > 0 ||
    props.comparisonBarGraphDataHot.length > 0 ||
    props.comparisonBarGraphDataOther.length > 0 ||
    props.comparisonBarGraphDataRTCool.length > 0 ||
    props.comparisonBarGraphDataRTHot.length > 0
  ) {
    //奇数:comparison**のデータをBarChartGraphから受け取る。(データ長≠0)
    //偶数:comparison**のデータをBarChartGraphから受け取らない。(データ長＝0)
    optionProps.colors = [
      graphColor[5],
      graphColor[6],
      graphColor[7],
      graphColor[8],
      graphColor[9],
      graphColor[0],
      graphColor[1],
      graphColor[2],
      graphColor[3],
      graphColor[4],
    ];
  } else {
    optionProps.colors = [
      graphColor[0],
      graphColor[1],
      graphColor[2],
      graphColor[3],
      graphColor[4],
    ];
  }

  if (
    (props.dateRange === 'day' ||
      (props.dateRange === 'week' &&
        (props.comparisonBarGraphDataCool.length > 0 ||
          props.comparisonBarGraphDataHot.length > 0 ||
          props.comparisonBarGraphDataOther.length > 0 ||
          props.comparisonBarGraphDataRTCool.length > 0 ||
          props.comparisonBarGraphDataRTHot.length > 0))) &&
    optionProps.xaxis &&
    optionProps.xaxis.labels
  ) {
    //データ取得範囲が1日の場合や比較状態かつデータ取得範囲が1週間の場合、
    //ラベルの間隔が狭く見づらくなるため、x軸のラベルを傾けるオプションを追加する
    optionProps.xaxis.labels.rotate = -45;
    optionProps.xaxis.labels.rotateAlways = true;
  } else if (optionProps.xaxis && optionProps.xaxis.labels) {
    //週比較状態からデータ取得範囲を変更したり、比較状態を解除した際に傾きを解除する設定
    optionProps.xaxis.labels.rotateAlways = false;
  }
  return {
    series: seriesProps,
    options: optionProps,
  };
};
